//@flow

import type {
  RelatedResourceParams,
  RelatedResourceCriteria,
} from '../../entities';

type GenericObjectType = 'PRODUCT' | 'CATEGORY' | 'SUBCATEGORY';

const RELATED_RESOURCE_CRITERIA: {
  [key: RelatedResourceCriteria]: string,
} = {
  PRODUCTS: 'products',
  CATEGORIES: 'categories',
  SUBCATEGORIES: 'subCategories',
};

export const RELATED_RESOURCE_CRITERIA_LABEL: {
  [key: RelatedResourceCriteria]: string,
} = {
  PRODUCTS: 'Productos',
  CATEGORIES: 'Categorías',
  SUBCATEGORIES: 'Subcategorías',
};

const RELATED_RESOURCE_OBJECT_TYPE: {
  [key: GenericObjectType]: RelatedResourceCriteria,
} = {
  PRODUCT: 'PRODUCTS',
  CATEGORY: 'CATEGORIES',
  SUBCATEGORY: 'SUBCATEGORIES',
};

export function getRelatedResourcesCriteria(
  criteria: GenericObjectType
): RelatedResourceCriteria {
  return RELATED_RESOURCE_OBJECT_TYPE[criteria];
}

export function getRelatedResourcesParams(
  criteria: RelatedResourceCriteria,
  ids: string[]
): RelatedResourceParams {
  const key = RELATED_RESOURCE_CRITERIA[criteria];

  return {
    [key]: ids,
  };
}
